import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

function CtaAction(props: any) {
    const { title, emailAction, desktopAction, mobileAction, mobileAlignCenter, mobileVisible } =
        props;
    const className = {
        cta: cx({
            cta: true,
            'cta--mobile-action-visible': mobileVisible,
        }),
        mobileAction: cx({
            'cta__action-mobile': true,
            'cta__action-mobile--center': mobileAlignCenter,
        }),
    };
    return (
        <div className={className.cta}>
            {title ? (
                <div className="cta__title">
                    <h2>{title}</h2>
                </div>
            ) : null}
            <div className="cta__controls">
                {emailAction ? <div className="cta__email-action">{emailAction}</div> : null}

                {mobileVisible ? null : <div className="cta__action-desktop">{desktopAction}</div>}

                <div className={className.mobileAction}>{mobileAction}</div>
            </div>
        </div>
    );
}

CtaAction.props = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    emailAction: PropTypes.node,
    desktopAction: PropTypes.node,
    mobileAction: PropTypes.node,
};

export default CtaAction;
